import { ElementRef,ViewChild,ChangeDetectorRef, HostBinding,Component,ViewEncapsulation, OnInit, OnDestroy,SimpleChanges, TemplateRef } from '@angular/core';
import { Subscription } from 'rxjs';
import {HomeService} from '../../services/home.service';
import { Router,ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {MessageService} from '../../message.service';
import {AppSettings} from '../../settings';
import {BaseComponent} from '../base/base.component';
import {ArticleService} from '../../services/article.service';
declare var $:any;
import * as moment from 'moment';
import { Template } from '@angular/compiler/src/render3/r3_ast';
// import { IDropdownSettings } from 'ng-multiselect-dropdown';


@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.css'],
  encapsulation:ViewEncapsulation.None
})
export class ArticleComponent extends BaseComponent implements OnInit ,OnDestroy {

   token:string='';

   articleId:number=-1;

    latestComments:any=[];

    selectedPendingArticleId:number=-1;

    selectedApprovedArticleId :number=-1;

    currentArticleIndex:number=-1;

    currentAction:string='';

    selectedPendingStatus:string='';

    textstatus:string='';

//    @ViewChild('textstatus', {static: false}) textstatus !: ElementRef;

    permissions:any=[];

    @HostBinding('style.width') public width: string = '100%';

    asset_path:string= AppSettings.API_ENDPOINT;

    record_offset:number= 0;

    per_page:number=10;

    loader_image:boolean=true;

    record_empty:number =0;

    toastr:any;

    notification :any=[];

    filter_status:Array<any>=[];

    selectedCategoryList:any=[];

    selectedCategoryType:any=[];

    articleCaregoryList:Array<any>= [];

    articleCaregoryType:Array<any>= [];

    sort_detail:any='updatedon';

    user:any;

    categoryError:string;

    categoryTypeError:string;

    dropdownSettings = {};

    dropdownSettings2 = {};

    dropdownSettings3 = {};

    dropdownSettings4 = {};
    dropdownSettings5 = {};

    searchTxt:string='';

    applied_filters:number=0;

    msg:any;

    records:any=[];

    count:any;

    orginalRecords:any=[];

    articleStatus:any = [
      
      {key:'draft',value:'Draft'},
      {key:'shared',value:'Shared'},
      {key:'delegated',value:'Delegated'},
      {key:'pending',value:'Pending'},
      {key:'approved',value:'Approved'},
      {key:'published',value:'Published'},
      {key:'external',value:'External'},
    ];

    orderList:any =[
      {'key':'updatedon','value':'Updated Date'},
      {'key':'createdon','value':'Created Date'}
    ];

    selectedOrder:any;

    isDescToggle:boolean=true;
    isSelectDesc:any=' desc';

    userName='';

    navigationsType=[];

    source:any;

    commentArticleId:any;
    commentArticleOffset:0;
    showLoadMore:boolean=true;

    aproverArticleId:any;
    aproverArticleOffset:0;
    showApproverLoadMore:boolean=true;
    latestApproverComments:any=[];

    countributorArticleId:any;
    showContributorLoadMore:boolean=true
    latestContributor:any=[]
    approverIndx:number=-1
    approverData:any
    coauthorIndx:number=-1
    coauthorData:any
    approverList:any=[]
    contributorList:any=[]

    copyArticleId:number=-1;

    checkedTitle:boolean=false;
    checkedShort:boolean=false;
    checkedBody:boolean=false;
    checkedHeader:boolean=false;
    checkedThum:boolean=false;
    checkedTag:boolean=false;

    countryList=[];
    country= [
      {key:'Australia',value:'Australia'},
      {key:'Austria',value:'Austria'},
      {key:'Bahrain',value:'Bahrain'},
      {key:'Belgium',value:'Belgium'},
      {key:'Bosnia & Herzegovina',value:'Bosnia & Herzegovina'},
      {key:'Bulgaria',value:'Bulgaria'},
      {key:'Canada',value:'Canada'},
      {key:'Croatia',value:'Croatia'},
      {key:'Cyprus',value:'Cyprus'},
      {key:'Czech Republic',value:'Czech Republic'},
      {key:'Denmark',value:'Denmark'},
      {key:'Estonia',value:'Estonia'},
      {key:'Finland',value:'Finland'},
      {key:'France',value:'France'},
      {key:'Germany',value:'Germany'},
      {key:'Greece',value:'Greece'},
      {key:'Hungary',value:'Hungary'},
      {key:'Iceland',value:'Iceland'},
      {key:'India',value:'India'},
      {key:'Ireland',value:'Ireland'},
      {key:'Israel',value:'Israel'},
      {key:'Italy',value:'Italy'},
      {key:'Japan',value:'Japan'},
      {key:'Latvia',value:'Latvia'},
      {key:'Lithuania',value:'Lithuania'},
      {key:'Luxembourg',value:'Luxembourg'},
      {key:'Macedonia',value:'Macedonia'},
      {key:'Malaysia',value:'Malaysia'},
      {key:'Malta',value:'Malta'},
      {key:'Moldova',value:'Moldova'},
      {key:'Netherlands',value:'Netherlands'},
      {key:'New Zealand',value:'New Zealand'},
      {key:'Norway',value:'Norway'},
      {key:'Palestine',value:'Palestine'},
      {key:'Phillipines',value:'Phillipines'},
      {key:'Poland',value:'Poland'},
      {key:'Portugal',value:'Portugal'},
      {key:'Qatar',value:'Qatar'},
      {key:'Montenegro',value:'Montenegro'},
      {key:'Serbia',value:'Serbia'},
      {key:'Romania',value:'Romania'},
      {key:'Russia',value:'Russia'},
      {key:'Saudi Arabia',value:'Saudi Arabia'},
      {key:'Slovakia',value:'Slovakia'},
      {key:'Slovenia',value:'Slovenia'},
      {key:'South Africa',value:'South Africa'},
      {key:'Spain',value:'Spain'},
      {key:'Sweden',value:'Sweden'},
      {key:'Switzerland',value:'Switzerland'},
      {key:'Thailand',value:'Thailand'},
      {key:'Turkey',value:'Turkey'},
      {key:'Ukraine',value:'Ukraine'},
      {key:'United Arab Erimates',value:'United Arab Erimates'},
      {key:'United Kingdom',value:'UK'},
      {key:'United States of America',value:'United States of America'}
      
      ];
      
    selectedCountry = [];

  constructor(private _activatedRoute: ActivatedRoute,private ref: ChangeDetectorRef,private articleService:ArticleService, msg:MessageService, toastr: ToastrService,homeservice:HomeService , private _router: Router) {


    super(msg,toastr,homeservice,_router);

    this.toastr=toastr;

    this.msg =msg;


    this._activatedRoute.queryParams.subscribe(params =>{

      if(params.source!=undefined){
        this.source = params.source;

      }
    })


  }


  check_permission_author(article,user){

    let author = (article.author !=undefined)?article.author:[];

    let ispermission =false

    author.map((x)=>{
      if(x==user.id){
        ispermission=true
      }
    })

    //  return (article.status =='Draft' || article.status =='Rejected') && ( article.history.createdId == user.id || ((author.join().indexOf(user.id) >= 0)?true:false))
     return (article.status =='Draft' || article.status =='Rejected') && ( article.history.createdId == user.id || ispermission)


  }

  check_permission_coauthor(article,user){


    let coauthor = (article.coauthor !=undefined)?article.coauthor:[];

    // return (article.status =='Pending' || article.status =='Rejected') && (approver.includes(user.id))
    // return (article.status =='Draft' || article.status =='Rejected') && ((coauthor.join().indexOf(user.id) >= 0)?true:false)
    let ispermission =false

    coauthor.map((x)=>{
      if(x==user.id){
        ispermission=true
      }
    })

    return (article.status =='Draft' || article.status =='Rejected') && ispermission



 }

 
  check_permission_reviewer(article,user){



    let approver = (article.approver !=undefined)?article.approver:[];

    // return (article.status =='Pending' || article.status =='Rejected') && (approver.includes(user.id))
    // return (article.status =='Pending' || article.status =='Rejected') && ((approver.join().indexOf(user.id) >= 0)?true:false)

    let ispermission =false

    approver.map((x)=>{
      if(x==user.id){
        ispermission=true
      }
    })

    return (article.status =='Pending' || article.status =='Rejected') && ispermission


  }

  check_permission_admin(record,user){

    // return  this.permissions.includes('manage_article') ;
    return ( this.permissions.join().indexOf('manage_article') >= 0)?true:false

   }

   check_permission_only_publisher(article,user){

    let publisher = (article.publisher !=undefined)?article.publisher:[];


    // return  publisher.includes(user.id) ;

    // return ( publisher.join().indexOf(user.id) >= 0)?true:false
    let ispermission =false

    publisher.map((x)=>{
      if(x==user.id){
        ispermission=true
      }
    })
    
    return ispermission

   }

   check_permission_only_reviewer(article,user){

    let approver = (article.approver !=undefined)?article.approver:[];

    // return approver.includes(user.id);

    // return ( approver.join().indexOf(user.id) >= 0)?true:false
    let ispermission =false

    approver.map((x)=>{
      if(x==user.id){
        ispermission=true
      }
    })
    
    return ispermission

   }

   check_permission_only_author(article,user){

    let author = (article.author !=undefined)?article.author:[];

    // return  ((article.history.createdId == user.id) || (( author.join().indexOf(user.id) >= 0)?true:false));
    let ispermission =false

    author.map((x)=>{
      if(x==user.id){
        ispermission=true
      }
    })
    
    return ((article.history.createdId == user.id) || ispermission)


   }

   check_permission_publisher(article,user){



    let publisher = (article.publisher !=undefined)?article.publisher:[];

    let ispermission =false

    publisher.map((x)=>{
      if(x==user.id){
        ispermission=true
      }
    })

    // return  (article.status =='Unpublished' || article.status =='Approved' || article.status =='Published' || article.status =='Rejected' ) && publisher.includes(user.id) ;

    
    // return  (article.status =='Unpublished' || article.status =='Approved' || article.status =='Published' || article.status =='Rejected' ) && (( publisher.join().indexOf(user.id) >= 0)?true:false);

    //ranjit 11.07.2022
    
    return  (article.status =='Unpublished' || article.status =='Approved' || article.status =='Published' || article.status =='Rejected' ) && ispermission;


   }

  get_title_type(type_str:string){

    let typestr = this.articleCaregoryType.find( (item) =>{ return item.key == type_str;});

     return (typestr!=undefined)?typestr.value:'';

  }

  sort_change(){

   

  }

  onItemSelect(item: any) {


    //console.log(item);


  }


  onStatusTypeAll($event){




    //this.filter_status = this.articleStatus;


  }
  onstatusDeSelect($event){

    this.filter_status = [];




  }
  onDeSelectStatusAll($event){

    this.filter_status = [];

  }


  onDeSelectCatAll(local:any){

    this.selectedCategoryList = [];

   

  }

  oncatDeSelect($event:any){

 
  }

  ontypeDeSelect($event:any){

  }

  onDeSelectTypeAll(local:any){

    this.selectedCategoryType=[];

  }

  onSelectCatAll(local:any) {

    this.categoryError='';
    this.selectedCategoryList = this.articleCaregoryList;

    // this.onDeSelectAll.emit(this.emittedValue(this.selectedItems));

  }

  onSelectTypeAll(tt:any){

    this.selectedCategoryType = this.articleCaregoryType;
  

  }
  onTypeSelect(item: any) {

    this.categoryTypeError='';


  }





  filter_records(offset:number){


      // //console.log(this.selectedCategoryList);

      this.record_offset = offset;

      let categories= [];

      this.selectedCategoryList.forEach(element => {

        categories.push(element.key);

      });

      let types= [];

      this.selectedCategoryType.forEach(element => {

        types.push(element.key);

      });

      let ft_sort='';

      ////console.log(this.sort_detail);

      if(this.sort_detail=='SORT'){

        ft_sort ='';

      } else{

        ft_sort =this.sort_detail +this.isSelectDesc;
      }

      let ft_status=[];


      this.filter_status.forEach(element => {

        ft_status.push(element.key);

      });

      this.applied_filters = 0;

      if(this.selectedCategoryList.length> 0){

        this.applied_filters++;
      }
      if(this.selectedCategoryType.length> 0){

        this.applied_filters++;
      }
      if(this.filter_status.length> 0){

        this.applied_filters++;
      }




      try{

        let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

        if(!tokenA) throw 'Error in parse';

        if(!JSON.parse(tokenA)) throw 'Error in json parse';

        tokenA = JSON.parse(tokenA);

        //console.log(offset);

        let country=[]

        this.selectedCountry.map((x)=>{
           country.push(x.value)
        })

        this.loader_image=true;


        let data={
          token:tokenA.token,
          desc:{ 
                  type:types,
                  category:categories,
                  search:this.searchTxt,
                  status:ft_status,
                  order:ft_sort,
                  limit:this.per_page,
                  offset:offset,
                  country:country,
                 'page':'article',
                 source: this.source
                }
        };

        this.articleService.articleDataFiltered(data).subscribe( (result)=>{

          result.article.map((x)=>{
            
            let arr=[]
            x.contributors.map((y)=>{
              if(x.coauthors.length>0){
                x.coauthors.map((z)=>{
                  let obj={}
                  if(y==z){
                    obj['isDouble']=false
                    obj['value']=y
                  }else{
                    obj['isDouble']=true
                    obj['value']=y
                  }
                  arr.push(obj)
                })
              }else{
                let obj={}
                obj['isDouble']=true
                obj['value']=y
                arr.push(obj)
              }
             
            })
            x['share']=arr;

            // console.log('ranjit',x.coauthors,x.contributors,x.share)
          })

              this.records = result.article;

              this.count = result.count;


              this.loader_image =false;


              if(this.record_offset ==0){

                 this.record_offset=10;

              }



             if (!this.ref['destroyed']) {
                 this.ref.detectChanges();
               }






        });



      }catch(e){

        //console.log(e);

        this._router.navigate(['/login']);

      }




  }



  filter_records_lazy(offset:number){


    this.record_empty =1;

    this.loader_image =true;

    //console.log('lazyfilter');


      // //console.log(this.selectedCategoryList);

      let categories= [];



      this.selectedCategoryList.forEach(element => {

        categories.push(element.key);

      });

      let types= [];

      this.selectedCategoryType.forEach(element => {

        types.push(element.key);

      });

      let ft_sort='';

      //console.log(this.sort_detail);

      if(this.sort_detail=='SORT'){

        ft_sort ='';

      } else{

        ft_sort =this.sort_detail + this.isSelectDesc;
      }

      // let ft_status=[];

      // if(this.filter_status.length==0){

      //    ft_status=[];

      // }else{

      //   ft_status = this.filter_status ;
      // }


      let ft_status= [];

       this.filter_status.forEach(element => {

        ft_status.push(element.key);

      });




      this.applied_filters = 0;

      if(this.selectedCategoryList.length> 0){

        this.applied_filters++;
      }
      if(this.selectedCategoryType.length> 0){

        this.applied_filters++;
      }
      if(this.filter_status.length> 0){

        this.applied_filters++;
      }




      try{

        let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

        if(!tokenA) throw 'Error in parse';

        if(!JSON.parse(tokenA)) throw 'Error in json parse';

        tokenA = JSON.parse(tokenA);

        //console.log(offset);



        let data={
          token:tokenA.token,
          desc:{  type:types,
                  category:categories,
                  search:this.searchTxt,
                  status:ft_status,
                  order:ft_sort,
                  limit:this.per_page,
                  offset:offset,
                  'page':'article',
                  source: this.source
                }
        };

        this.articleService.articleDataFiltered(data).subscribe( (result)=>{




         if(result.status =='success'){

          this.loader_image =false;


          if(result.article.length > 0){

            this.record_empty =0;


            if(this.records.length ==0 ){


              this.records = result.article;

              if (!this.ref['destroyed']) {
                this.ref.detectChanges();
              }



            }

            else{


              result.article.forEach(element => {



               this.records.push(element);



               if (!this.ref['destroyed']) {
                this.ref.detectChanges();
              }

             });


            }




          }else{

            this.record_empty =1;



          }




         } else{

            this.loader_image =false;

            this._router.navigate(['/login']);

         }





        });



      }catch(e){

        this._router.navigate(['/login']);



      }




  }

  searchChange(){

    this.filter_records(0);

  }

  searchItems(){

    this.filter_records(0);
    $('#desk-filter').hide();
    $(".modal_backdrop_bg").hide();




  }

  sortDesc(){

    this.isDescToggle = false;
    this.isSelectDesc = ' asc';
    this.filter_records(0);


  }

  sortAsc(){

    this.isDescToggle = true;
    this.isSelectDesc = ' desc';
    this.filter_records(0);

  }


  sort_detail_change($event:any){




    let categoryarr=this.selectedOrder[0].key;

    //console.log(categoryarr);

    this.sort_detail = categoryarr;

    this.filter_records(0);


   if(window.innerWidth > 992){
    $('#mob-sort.dropdown-box').css('max-width',(this.selectedOrder[0].value.length*15)+'px');
   }


  }



  status_change(event){




     let categoryarr=[]

        this.filter_status.map((x)=>{
          categoryarr.push(x)
        })


        this.filter_status = categoryarr;

  }



  check_newslettercontrol_exists(){

    return this.permissions.indexOf("control_newsletter") > -1;

  }


  check_mange_exists(){

    return this.permissions.indexOf("manage_article") > -1;

  }


  check_control_exists(){

    return  this.permissions.indexOf("control_article") > -1;

  }

  check_message_exists(){

    return  this.permissions.indexOf("control_article") > -1 ||  this.permissions.indexOf("manage_article") > -1;
  }

  check_create_exists(){

    // return this.permissions.indexOf("control_article") > -1 ||  this.permissions.indexOf("create_article") > -1 ||  this.permissions.indexOf("manage_article") > -1;

    return  this.permissions.indexOf("create_article") > -1;

  }

  check_status_filter_exists(){

    return  this.permissions.indexOf("create_article") > -1 ||  this.permissions.indexOf("manage_article") > -1;

  }


  archive_popup(id:number){

    this.articleId = id;

    $('#success-popup').modal('show');


  }


  deleteArticle(){






    let data={
      token:this.token,
      reqData:{
        id:this.articleId,
        archive:true,
        'page':'article'
      }

      //offset:this.record_offset
    }


    this.articleService.removeArticle(data).subscribe( (res)=>{



      if(res.status=='success'){

        let catI = this.records.findIndex( (elm) => { return  elm.id ==  this.articleId});


        this.records.splice(catI,1);

        this.articleId =0;


      }else{
        this.articleId =0;
      }

    });


  }

  copy_popup(id:number){

    this.copyArticleId=id
    $('#copy-popup').modal('show');

  }

  checkedTitleChange(event){
   this.checkedTitle=event

  }
  checkedShortChange(event){
   this.checkedShort=event
  }
  checkedBodyChange(event){
    this.checkedBody=event

  }
  checkedHeaderChange(event){
     this.checkedHeader=event
  }
  checkedThumChange(event){
   this.checkedThum=event
  }
  checkedTagChange(event){
    this.checkedTag=event
  }

  copyArticle(){

    if(this.checkedTitle==false && this.checkedShort==false && this.checkedBody==false && this.checkedHeader==false && this.checkedThum==false && this.checkedTag==false){
      this.toastr.error('Please select atleast one element you want to copy!', '', {timeOut: 3000});
      $('#copy-popup').modal('show');
    }else{
      let data={
        articleId:this.copyArticleId,
        title:this.checkedTitle,
        short:this.checkedShort,
        body:this.checkedBody,
        header:this.checkedHeader,
        thumb:this.checkedThum,
        tag:this.checkedTag
      }
      this.msg.sendMessage({'type':'copyArticle','data':data });
      $('#copy-popup').modal('hide');
      this.checkedTitle=false;
      this.checkedShort=false;
      this.checkedBody=false;
      this.checkedHeader=false;
      this.checkedThum=false;
      this.checkedTag=false;

      this._router.navigate(['/article/create'], { queryParams: { 'source':'article'} });
      
    }

    

  }
  



  ngOnInit() {



    window.scrollTo(0, 0);


    this.dropdownSettings = {
        singleSelection: false,
        idField: 'key',
        textField: 'value',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: true
      };
      this.dropdownSettings2 = {
        singleSelection: false,
        idField: 'key',
        textField: 'value',
        itemsShowLimit: 1,
        allowSearchFilter: true,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',

      };

      this.dropdownSettings3 = {
        singleSelection: false,
        idField: 'key',
        textField: 'value',
        itemsShowLimit: 2,
        allowSearchFilter: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',

      };

      this.dropdownSettings5 = {
        singleSelection: false,
        idField: 'key',
        textField: 'value',
        itemsShowLimit: 3,
        allowSearchFilter: false,
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',

      };

      this.dropdownSettings4 = {
        singleSelection: true,
        idField: 'key',
        textField: 'value',
        closeDropDownOnSelection:true
      };





    try{

        let tokenA:any = (localStorage.getItem('token')!=undefined )?atob(localStorage.getItem('token')): 0;

        if(!tokenA) throw 'Error in parse';

        if(!JSON.parse(tokenA)) throw 'Error in json parse';

        tokenA = JSON.parse(tokenA);

        this.token =tokenA.token;

        let data={
          token:tokenA.token
        }


        this.articleService.getCategoryList(data).subscribe( (result)=>{

            this.user=result.user;

            if(result.status=='success'){

             // this.msg.sendMessage({'user':result.name,'type':'left_menu_link','navigations':result.navigation})

             this.userName=result.user.name;

             this.navigationsType=result.navigation;

             this.notification = result.notification;

             this.broadcast_menu();

             this.articleService.getCategoryType(data).subscribe( (res)=>{

              if(res.status=='success'){

                this.articleCaregoryType=res.type;

                this._activatedRoute.queryParams.subscribe(

                  params =>{

                    if(params['type']!=undefined){

                          this.articleCaregoryType=res.type
                          let cats=  this.articleCaregoryType.filter( (cat)=> { return cat.key == params['type'];});

                          this.selectedCategoryType =cats;

                          this.filter_records(0);

                    }
                    else if(params['category']!=undefined){


                      let p = [];


                      if(params['category'].indexOf(',')>=0){

                         p = params['categorroley'].split(",");

                       }

                       if(p.length > 0 ){

                        this.articleCaregoryList=result.category;

                        let cats=  this.articleCaregoryList.filter( (cat)=> { return p.indexOf(cat.key) !== -1;});

                        this.selectedCategoryList = cats;

                        this.filter_records(0);


                       } else{

                        this.articleCaregoryList=result.category;

                        let cats=  this.articleCaregoryList.filter( (cat)=> { return cat.key == params['category'];});

                        this.selectedCategoryList =cats;

                        this.filter_records(0);

                       }


                      // //console.log(params);





                    } else{

                      this.selectedCategoryList=[];
                      this.selectedCategoryType=[];

                      this.articleCaregoryList=result.category;

                      this.filter_records(0);

                    }

                  })



              }else{

                this.toastr.error('Category Type Not Found  !', '', {timeOut: 3000});
              //  this._router.navigate(['/login']);
              this._router.navigate(['/login']);

              }
             });







             this.permissions = (result.permission !=undefined || result.permission!=null)? result.permission:[];

          //  console.log(this.permissions);




            }else{

              this.toastr.error('Category List Not Found  !', '', {timeOut: 3000});
              this._router.navigate(['/login']);

            }
        });




      } catch(exec){
         this.toastr.error('Category List Not Found  !', '', {timeOut: 3000});
        // this._router.navigate(['/login']);
        this._router.navigate(['/login']);
      }

   
      let arr=[]
      this.country.map((x)=>{
        let obj={}
        obj['key']=x.key.toUpperCase()
        obj['value']= x.value
        arr.push(obj)
      })
      this.countryList=arr


  }

  onCountrySelect($event){

  }

  onCountrySelectAll($event){

  }

  onCountryDeSelect($event){

  }

  onCountryDeSelectAll($event){

  }


  movetonext(id:Number){

    ////console.log(id);

    $('[data-toggle="popover"]').popover('hide');

    $('.tooltip-custom').tooltip("hide");

    this._router.navigate(['/article/'+id+'/edit']);


  }

  viewArticle(id:number){

    $('[data-toggle="popover"]').popover('hide');

    $('.tooltip-custom').tooltip("hide");

    this._router.navigate(['/article/'+id+'/view'], { queryParams: { 'source':'article'} });
  }


  statusText(text:string){




  // console.log(this.selectedApprovedArticleId);
  // console.log(this.selectedPendingArticleId);
  // console.log(this.selectedPendingStatus);
  // console.log(text);





  $('#approve-popup').modal('hide');

  // console.log(this.textstatus);


if(this.selectedPendingArticleId > -1 ){





if(this.selectedPendingStatus=='Approve'){


  this.articleService.articleStatus({'token':this.token,'reqData':{article:this.selectedPendingArticleId,comment:this.textstatus,approve:true}}).subscribe( (e)=>{

    // console.log(e);

    this.textstatus='';

    if(e.status=='success'){

      // console.log(this.currentArticleIndex);
      this.records[this.currentArticleIndex].status ='Approved';
      this.selectedPendingArticleId = -1;




    }



  });



}else if(this.selectedPendingStatus=='Reject'){


  this.articleService.articleStatus({'token':this.token,'reqData':{article:this.selectedPendingArticleId,comment:this.textstatus,reject:true}}).subscribe( (e)=>{

    // console.log(e);

    this.textstatus='';

    if(e.status=='success'){

      // console.log(this.currentArticleIndex);
      this.records[this.currentArticleIndex].status ='Rejected';
      this.selectedPendingArticleId = -1;


    }









  });


}



}


if(this.selectedApprovedArticleId > -1){



  if(this.selectedPendingStatus=='Published'){

    this.articleService.articleStatus({'token':this.token,'reqData':{article:this.selectedApprovedArticleId,comment:this.textstatus,publish:true}}).subscribe( (e)=>{



      this.textstatus='';

      if(e.status=='success'){


        this.records[this.currentArticleIndex].status ='Published';
        this.selectedApprovedArticleId = -1;


      }



    });



  }else if(this.selectedPendingStatus=='Reject'){


    this.articleService.articleStatus({'token':this.token,'reqData':{article:this.selectedPendingArticleId,comment:this.textstatus,reject:true}}).subscribe( (e)=>{


      this.textstatus='';

      if(e.status=='success'){


        this.records[this.currentArticleIndex].status ='Rejected';
        this.selectedApprovedArticleId = -1;


      }









    });


  }




}




}





  ngAfterViewInit(){

   
    

      $(document).ready(function() {

        window.scrollTo(0, 0);


        $('[data-toggle="popover"]').popover('hide');

        $('.tooltip-custom').tooltip("hide");



        $('#desk-filter-btn').on('mouseover',function(e){



        });
        $('#desk-filter-btn ').on('mouseout',function(e){



        });




        $('body').on('click','.template-status',function(e){



          e.stopPropagation()


          var $pending = e.target.classList.contains('pending');



          var $approved_now = e.target.classList.contains('approved');



          if($pending){



            var $articleid = e.target.dataset.articleid;

            var $currentArticleIndex =e.target.dataset.index;


            this.selectedPendingArticleId = $articleid;

            this.selectedApprovedArticleId = -1;

            this.currentArticleIndex = $currentArticleIndex;



          }


          if($approved_now){



            var $articleid = e.target.dataset.articleid;

            var $currentArticleIndex =e.target.dataset.index;



            this.selectedPendingArticleId = -1;

            this.selectedApprovedArticleId = $articleid;

            this.currentArticleIndex = $currentArticleIndex;



          }





        }.bind(this));



       $('body').on('click','.tooltip-custom',function(){

         $(this).tooltip("hide");




       });


       let tl:any= $('body');
         tl.tooltip({
          trigger: "hover" ,
          selector: '.tooltip-custom'
      });

      tl.on('show.bs.tooltip', () => {
        //$('.tooltip-custom').not(this).remove();
      });





        $(window).on("scroll", function() {




          // if(this._router.url == '/article' || this._router.url.includes('/article?category') || this._router.url.includes('/article?type')){

            if(this._router.url == '/article' || (this._router.url.indexOf('/article?category')>=0) || (this._router.url.indexOf('/article?type')>=0)){



            if ($(window).scrollTop() + $(window).height() > $(document).height() - 100) {




               if(this.record_empty == 0 && this.record_offset > 0 ){


                  this.record_empty =1;


                  this.filter_records_lazy(this.record_offset);

                  this.record_offset+=this.per_page;

                }


            }




          }





        }.bind(this));




        var popOverSettings = {
          placement: 'bottom',
          container: 'body',
          html: true,
          selector: '[data-toggle="popover"]', //Sepcify the selector here
          content: function () {

              //  //console.log( $(this).attr('data-popover-content'));
              return $( $(this).attr('data-popover-content')).html();
          }
      }

    //  $('body').popover(popOverSettings);



       // $('[data-toggle="tooltip"]').tooltip();

        $('input').blur(function(event) {
            var inputValue = this.value;
            if (inputValue) {
                this.classList.add('value-exists');
            } else {
                this.classList.remove('value-exists');
            }
        });

        
        //comments left sidebar
        $('body').on('click','.comments',function(event) {

            event.stopPropagation();
            $("#comments_left_sidebar").addClass("menu-open");
            

             var $id = event.currentTarget.dataset.articleid;

              this.commentArticleId = $id;

              //console.log('')

              this.showLoadMore = true

              this.articleService.articleStatus({'token':this.token,'reqData':{'article':$id,'offset':0}}).subscribe( (result)=>{



               if(result.status=='success'){


                this.latestComments= result.workflow;


              if (!this.ref['destroyed']) {
                this.ref.detectChanges();
              }





               } else{

                this.latestComments= [];


               }

              });





            //$(".main-menu").addClass("mob-menu-bg");

        }.bind(this));


        //ranjit
        $('body').on('click','.pending',function(event) {

          
          event.stopPropagation();
          $("#approval_left_sidebar").addClass("menu-open")
          

           var $id = event.currentTarget.dataset.articleid;

           this.aproverArticleId = $id;

             this.showApproverLoadMore = true

             this.articleService.articleStatus({'token':this.token,'reqData':{'article':$id,'offset':0,status:['Pending','Approved']}}).subscribe( (result)=>{



             if(result.status=='success'){

              // var dups = [];
              // var arr = result.workflow.filter(function(el) {
              //   // If it is not a duplicate, return true
              //   if (dups.indexOf(el.history.createdBy) == -1) {
              //     dups.push(el.history.createdBy);
              //     return true;
              //   }

              //   return false;
                
              // });
              //  this.latestApproverComments= arr;

              let dups=[],arr=[]
              for(let i=0;i<result.workflow.length;i++){
                if (dups.indexOf(result.workflow[i].history.createdId) == -1) {
                      dups.push(result.workflow[i].history.createdId);
                      arr.push(result.workflow[i])
                    }
              }
              this.latestApproverComments= arr;
//result.workflow.slice(1)
            if (!this.ref['destroyed']) {
              this.ref.detectChanges();
            }





             } else{

               this.latestApproverComments= [];


             }

            });





          //$(".main-menu").addClass("mob-menu-bg");

      }.bind(this));


      //ranjit contributor

      $('body').on('click','.share_new',function(event) {

          
        event.stopPropagation();
        $("#contributor_left_sidebar").addClass("menu-open")
        

         var $id = event.currentTarget.dataset.articleid;


           this.countributorArticleId = $id;

           this.showContributorLoadMore = true

           this.articleService.articleStatus({'token':this.token,'reqData':{'article':$id,'offset':0,status:['Shared','Contributed']}}).subscribe( (result)=>{



           if(result.status=='success'){

            let dups=[],arr=[]
            for(let i=0;i<result.workflow.length;i++){
              if (dups.indexOf(result.workflow[i].history.createdId) == -1) {
                    dups.push(result.workflow[i].history.createdId);
                    arr.push(result.workflow[i])
                  }
            }
            this.latestContributor= arr;

          if (!this.ref['destroyed']) {
            this.ref.detectChanges();
          }





           } else{

             this.latestContributor= [];


           }

          });



      }.bind(this));

      //end here

        //ranjit

        $(".msg-box-close").click(function() {

            $("#comments_left_sidebar").removeClass("menu-open");
            //$(".main-menu").removeClass("mob-menu-bg");

        });
        $("#msg-box-close1").click(function() {

          $("#approval_left_sidebar").removeClass("menu-open")
         

      });

      $("#msg-box-close2").click(function() {

        $("#contributor_left_sidebar").removeClass("menu-open")
       

      });
        $('body').click(function() {

            $("#comments_left_sidebar").removeClass("menu-open");
            $(".main-menu").removeClass("mob-menu-bg");

        });

        var popOverSettings2 = {
          placement: 'bottom',
          trigger : 'hover',
          container: 'body',
          html: true,
          selector: '[data-toggle="popover"]', //Sepcify the selector here
          content: function () {
   
            var content = '#share-details-info-'+$(this).attr("data-popover-content");
            
            return $(content).children(".popover-body").html();
    
    
          }
      }
     
      $('body').popover(popOverSettings2);



        $(document).on('click', function(e) {
            $('[data-toggle="popover"],[data-original-title]').each(function() {
                //the 'is' for buttons that trigger popups
                //the 'has' for icons within a button that triggers a popup
                if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    (($(this).popover('hide').data('bs.popover') || {}).inState || {}).click = false // fix for BS 3.3.6
                }

            });
        });

        $(document).on('click', '.dropdown-menu', function (e) {
            e.stopPropagation();
          });

          

    }.bind(this));



//mobile open filter and sorting_area$(function() {
		$('#shorting_box').on('click', function() {
			$("#mob-sort").show();
			$(".modal_backdrop_bg").show();
		});
		$(function() {
		$('.filter-close').on('click', function() {
			$("#mob-filter").hide();
			$(".modal_backdrop_bg").hide();
		});
	});

		$('#filter_box').on('click', function() {
			$("#mob-filter").show();
			$(".modal_backdrop_bg").show();
		});
			$('.sort-close').on('click', function() {
			$("#mob-sort").hide();
			$(".modal_backdrop_bg").hide();
		});
			$('.filter-close-des').on('click', function() {
			$("#desk-filter").hide();
			$(".modal_backdrop_bg").hide();
		});

		$("#search-ico").click(function(){
			  $("#mob-search").slideToggle("fast").toggleClass('db');
			});


$('#desk-filter-btn').on('click', function() {
			$("#desk-filter").show();
			$(".modal_backdrop_bg").show();
    });
    
  

  }

  closeFilterPop(id:string){

    $("#"+id).hide();
    //$("#mob-filter").hide();
    $(".modal_backdrop_bg").hide();

  }

  reset(){

    this.selectedCategoryList = [];
    this.selectedCategoryType = [];
    this.sort_detail = 'updatedon';
    this.searchTxt = '';
    this.filter_status = [];
    this.filter_records(0);

    $('.search-temp').removeClass('value-exists');

  }


  LoadMoreArticle(){

    event.stopPropagation();

    this.articleService.articleStatus({'token':this.token,'reqData':{'article':this.commentArticleId,'offset':this.latestComments.length}}).subscribe( (result)=>{

      if(result.status=='success'){

        if(result.workflow.length>0){
          result.workflow.map((x)=>{
            this.latestComments.push(x)
          })

          if(result.workflow.length<5){
            this.showLoadMore = false
          }
          
        }else{
          this.showLoadMore = false
        }

      }
    })
   
    
  }


  LoadMoreApproveArticle(){

    event.stopPropagation();

    this.articleService.articleStatus({'token':this.token,'reqData':{'article':this.aproverArticleId,'offset':this.latestApproverComments.length,status:['Pending','Approved']}}).subscribe( (result)=>{

      if(result.status=='success'){

        let dups=[],arr=[]
        for(let i=0;i<result.workflow.length;i++){
          if (dups.indexOf(result.workflow[i].history.createdId) == -1) {
                dups.push(result.workflow[i].history.createdId);
                arr.push(result.workflow[i])
              }
        }

        if(arr.length>0){
          arr.map((x)=>{
            this.latestApproverComments.push(x)
          })

          if(arr.length<5){
            this.showApproverLoadMore = false
          }
          
        }else{
          this.showApproverLoadMore = false
        }

      }
    })
   
    
  }

  LoadMoreContributorArticle(){

    event.stopPropagation();

    this.articleService.articleStatus({'token':this.token,'reqData':{'article':this.countributorArticleId,'offset':this.latestContributor.length,status:['Shared','Contributed']}}).subscribe( (result)=>{

      if(result.status=='success'){

        let dups=[],arr=[]
        for(let i=0;i<result.workflow.length;i++){
          if (dups.indexOf(result.workflow[i].history.createdId) == -1) {
                dups.push(result.workflow[i].history.createdId);
                arr.push(result.workflow[i])
              }
        }

        if(arr.length>0){
          arr.map((x)=>{
            this.latestContributor.push(x)
          })

          if(arr.length<5){
            this.showContributorLoadMore = false
          }
          
        }else{
          this.showContributorLoadMore = false
        }

      }
    })
   
    
  }

  broadcast_menu(){


    this.msg.sendMessage({'user':this.userName,'notification':this.notification,'type':'left_menu_link','navigations':this.navigationsType,currentPage:'article'});


  }

  get_category_type(type:string,indx:any){

    let categoryList = this.records[indx].category

    let typestr = this.articleCaregoryList.find( (item) =>{ return item.key == type;});

    if(typestr==undefined){
      var index = categoryList.indexOf(type);
      if (index > -1) {
        categoryList.splice(index, 1);
      }
      this.records[indx].category = categoryList
    }
     return (typestr!=undefined)?typestr.value:'';

  }

  trackCategory(category){
    this.msg.sendMessage({type:'customeEvent',event:'category',value:category,source:'article'});

  }

  deleteApprover(indx,comment,latestApproverComments){

    this.approverIndx=indx
    this.approverData=comment
    this.approverList=latestApproverComments
    
    $('#deleteapprove-popup').modal('show');

  }

  deleteAapproveList(){
    
    let data={
      unreview:true,
      id:this.approverData.id,
      article:this.approverData.article,
      user:this.approverData.history.createdId
    }
   
    let index=this.approverIndx
  //  console.log('fffkkk',this.approverList)
    this.articleService.articleStatus({'token':this.token,'reqData':data}).subscribe( (result)=>{

      if(result.status=='success'){

        this.latestApproverComments.splice(index, 1);
       
        this.filter_records(0);
      } 
      
     });
    
    
  }

  deleteCoauthor(indx,comment){

    this.coauthorIndx=indx
    this.coauthorData=comment

    $('#deletecoauthor-popup').modal('show');

  }

  deleteCoauthorList(){

    let data={
      unshare:true,
      id:this.coauthorData.id,
      article:this.coauthorData.article,
      user:this.coauthorData.history.createdId
    }
   
    let index=this.coauthorIndx
   
    
    this.articleService.articleStatus({'token':this.token,'reqData':data}).subscribe( (result)=>{

      if(result.status=='success'){
   
        this.latestContributor.splice(index, 1);

        this.filter_records(0);
      } 
      
     });
   
    
    
  }



}


